<a
  href="https://www.ixsystems.com"
  target="_blank"
  ixTest="ixsystems"
>
  <ix-icon
    tabindex="0"
    [class]="['ix-logo', screenSize$ | async, logoIcon$ | async]"
    [name]="logoIcon$ | async"
  ></ix-icon>
</a>
